// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"b1ee6a31","821":"80d05a80"}[chunkId] + ".chunk.js";
};